export default __webpack_public_path__ + "static/media/Snd_Try5.0e4e2d8d.mp3";